// TODO: This should be part of the core
export function removeBlank(obj: any): any {
  obj = obj || {};
  return Object.keys(obj)
    .filter(k => obj[k] != null && obj[k] != '' && obj[k] != '[]' && obj[k] != '{}')
    .reduce((a, k) => ({ ...a, [k]: obj[k] }), {});
}
